import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, SpacerElement } from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<SpacerElement>["defaultData"] = {
  attributes: {
    height: "20px",
  },
  data: {},
};

export const Spacer = createBlock<SpacerElement>({
  get name() {
    return t("Spacer");
  },
  defaultData,
  type: BasicType.SPACER,
  create: (payload) => {
    const defaultData: SpacerElement = {
      type: BasicType.SPACER,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.SPACER,
  render(params) {
    return <BasicBlock params={params} tag="mj-spacer" />;
  },
});
